import React, { useState, forwardRef } from 'react';

// CONTEXT
import { useTheme } from 'context/ThemeContext';

// COMPONENTS
import SearchBar from './searchBarComponent';
import Profile from '../profileComponent';
import CustomizationDrawer from './customizationDrawerComponent';
import TooltipComponent from '../tooltipComponent';

// ICONS
import { PanelLeftOpen, SlidersHorizontal } from 'lucide-react';

const Header = forwardRef(({ isSidebarOpen, setIsSidebarOpen, searchRef, email }, ref) => {
    const { theme } = useTheme();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    return (
        <>
        <header ref={ref} className="w-full px-4 py-2 flex items-center justify-between">
            {/* Open sidebar */}
            {!isSidebarOpen && (
                <TooltipComponent content={'Ouvrir la barre latérale'} placement="right" theme={theme}>
                    <div
                        onClick={() => setIsSidebarOpen(true)}
                        className="p-2 rounded-lg hover:bg-noir/10 dark:hover:bg-gris/40 cursor-pointer"
                    >
                    <PanelLeftOpen className="text-noir dark:text-blanc" size={24} />
                    </div>
                </TooltipComponent>
            )}

            {/* Barre de recherche centrée */}
            <div className={`flex-1 mr-4 ${isSidebarOpen ? 'ml-0' : 'ml-4'}`}>
                <SearchBar 
                    ref={searchRef}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    isGlobalSearch={true}
                />
            </div>

            {/* Filtres + Profil à droite */}
            <div className="flex items-center">
                <TooltipComponent content={'Ouvrir le personnalisateur'} placement="left" theme={theme}>
                    <div
                        onClick={() => setDrawerOpen(true)}
                        className="p-2 rounded-lg hover:bg-noir/10 dark:hover:bg-gris/40 cursor-pointer"
                    >
                    <SlidersHorizontal className="text-noir dark:text-blanc" size={24} />
                    </div>
                </TooltipComponent>
                {/* <ProfilePicture /> */}
                <Profile email={email} />
            </div>
        </header>

        {/* Drawer flottant */}
        <CustomizationDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
        </>
    );
});

export default Header;